//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.DriveChainItemBuilderList.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
import "../no/ObjectList.js";
let d=[[[1,"DpmcvDriveCurves",0,"CAM.DriveChainItemBuilderList",0],[1,"DpmcvEndPercBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DpmcvNumSegsBuilder",0,"CAM.InheritableIntBuilder",0],[1,"DpmcvStartPercBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DpmcvStepTolBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"DpmcvStepType",1,0]],[[["section"],"CreateDpmcvDriveCurve",{R_:{curve:"CAM.DriveChainItemBuilder"}},1,0]],[]];
SPLM.CAM.DmCurveBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmCurveBuilder.DpmcvStepTypes = Object.freeze({
    "Tolerance" : "Tolerance", "Number" : "Number"});

export default SPLM;